import { useState, useEffect } from "react";
import { toast } from "../../../../components/toastNotification";
import TextInput from "../../../../components/TextInput";
import { useRecoilState, useRecoilValue } from "recoil";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import TargetSystemForm from "./TargetSystemForm";
import AddButton from "../../../../components/AddButton";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import MaterialExTable from "../../../../components/tables/MaterialExTable";

import useTargetSystem from "./hooks/useTargetSystem";
import useDeleteTargetSystem from "./hooks/useDeleteTargetSystem";
import useUpdateTargetSystem from "./hooks/useUpdateTargetSystem";
import {
  addStateTargetSystem,
  selectedRowsStateTargetSystem,
  setFilterTextStateTargetSystem,
} from "./atoms/atoms";
import TableFilters from "./TableFilters";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { notificationFilterById } from "../../../../actions/Utilities/NotificationFilter";
import { useHistory, useLocation } from "react-router-dom";
import EditButton from "../../../../components/EditButton";
import CancelButton from "../../../../components/CancelButton";
import SaveButton from "../../../../components/SaveButton";

const TargetSystemTable = () => {
  //Hooks Call
  const { data, isFetching } = useTargetSystem();
  const UpdateTargetSystem = useUpdateTargetSystem();
  const BulkDeleteTargetSystemType = useDeleteTargetSystem();
  //Atoms Call
  const [actionAddState, setActionAddState] =
    useRecoilState(addStateTargetSystem);
  const [selectedRows, setSelectedRows] = useRecoilState(
    selectedRowsStateTargetSystem
  );
  //Local States
  const [rowsCount, setRowsCount] = useState(0);
  const [editRowId, setEditRowId] = useState(null);
  const [actionEditState, setActionEditState] = useState(false);
  const [empTypeIsExist, setEmpTypeIsExistState] = useState(false);
  const [empTypeDataIsChange, setEmpTypeDataIsChange] = useState(false);
  const [checkStatus, setCheckStatus] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [hasTargetSystem, setHasTargetSystem] = useState(true);
  const [isBulkSelected, setIsBulkSelected] = useState(false);
  const [filterText, setFilterText] = useRecoilState(
    setFilterTextStateTargetSystem
  );
  const [disabledButton, setDisabledButton] = useState(false);
  const [edit, setEdit] = useState(false);
  const [displayNote] = useState(false);
  const [hideColumn, sethideColumn] = useState(false);

  const addPermission =
    PERMISSIONS.permission_utilities_configureagreement_targetsystem_add;
  const editPermission =
    PERMISSIONS.permission_utilities_configureagreement_targetsystem_edit;
  const deletePermission =
    PERMISSIONS.permission_utilities_configureagreement_targetsystem_delete;

  const [targetSystemFilteredData, setTargetSystemFilteredData] = useState([]);

  const userPermissions = useRecoilValue(permissionsSelector);
  const defaultValues = {
    description: "",
    targetSystemName: "",
    modifiedDate: "",
    modifiedBy: "",
    isActive: false,
  };
  const [empNewData] = useState([defaultValues]);

  //For filtered data update
  const [targetSysId, setTargetSysId] = useState("");
  useEffect(() => {
    if (targetSysId?.includes(".")) {
      let ids = targetSysId.split(".");
      const arr = ids.map((id) => Number(id));
      const filteredData = data?.filter((x) => arr.includes(x.targetSystemId));
      setTargetSystemFilteredData(filteredData);
    } else {
      const filteredData = data?.filter(
        (x) => x.targetSystemId === Number(targetSysId)
      );
      setTargetSystemFilteredData(filteredData);
    }
  }, [targetSysId, data]);

  let location = useLocation();
  const history = useHistory();
  let recordIdFromRecent = "";
  if (location.state == null) {
    //Do nothing
  } else {
    recordIdFromRecent = location.state;
  }

  useEffect(() => {
    if (recordIdFromRecent !== "") {
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName
        ).then((result) => {
          setTargetSystemFilteredData(result);
          setTargetSysId(recordIdFromRecent.recordId);
          history.replace();
        });
      } catch (error) {}
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, [history, recordIdFromRecent]);

  useEffect(() => {
    setEmpTypeIsExistState(false);
    setEmpTypeDataIsChange(false);
    setActionAddState(false);
    setActionEditState(false);
    setSelectedRows([]);
    setEditRowId([]);
  }, [setActionAddState, setSelectedRows]);

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows.filter((x) => x.isActive);
    setSelectedRows(forDelete);
    setRowsCount(forDelete.length);
    setIsBulkSelected((prev) => !prev);
  };

  const handleCheckBox = (checked) => {
    setEmpTypeDataIsChange(true);
    checked ? setCheckStatus(true) : setCheckStatus(false);
    checked
      ? empNewData.map((x) => (x.isActive = true))
      : empNewData.map((x) => (x.isActive = false));
  };

  const handleEditFieldsChange = (SourceType, fieldName, row, inputvalue) => {
    setEmpTypeIsExistState(false);
    setEmpTypeDataIsChange(false);
    inputvalue = inputvalue.trim();
    if (SourceType === "targetSystem") {
      if (fieldName === "TargetSystemName") {
        setEmpTypeDataIsChange(true);
        const result = data.filter(
          (item) =>
            item.targetSystemName.toUpperCase() === inputvalue.toUpperCase()
        )[0];
        result !== undefined
          ? setEmpTypeIsExistState(true)
          : setEmpTypeIsExistState(false);
        empNewData.map((x) => (x.targetSystemName = inputvalue));
        inputvalue === ""
          ? setHasTargetSystem(false)
          : setHasTargetSystem(true);
      }
      if (fieldName === "Description") {
        setEmpTypeDataIsChange(true);
        empNewData.map((x) => (x.description = inputvalue));
      }
    }
  };

  const handleEditButton = (rowData) => {
    setEditRowId(rowData.targetSystemId);
    setEmpTypeDataIsChange(false);
    setCheckStatus(rowData.isActive);
    setEdit(true);
    sethideColumn(false);
    empNewData.map((x) => (x.isActive = rowData.isActive));
    empNewData.map((x) => (x.targetSystemId = rowData.targetSystemId));
    empNewData.map((x) => (x.targetSystemName = rowData.targetSystemName));
    empNewData.map((x) => (x.description = rowData.description));
    empNewData.map((x) => (x.createdBy = rowData.createdBy));
    empNewData.map((x) => (x.createdDate = rowData.createdDate));
  };

  //Save changes
  const handleSave = (empNewData) => {
    if (empTypeDataIsChange) {
      if (!empTypeIsExist) {
        if (empNewData.filter((x) => x.targetSystemName) !== "") {
          UpdateTargetSystem(empNewData);
          setEditRowId([]);
          setSelectedRows([]);
          setEmpTypeIsExistState(false);
          setEmpTypeDataIsChange(false);
          setOpenModalEdit(false);
          setActionEditState(false);
          setDisabledButton(false);
          setEdit(false);
          sethideColumn(false);
        } else {
          toast.fire(
            "Saving Failed",
            "All required fields must be filled!",
            "error"
          );
          setOpenModalEdit(false);
        }
      } else {
        toast.fire(
          "Saving Failed",
          "Policy Management System already exists!",
          "error"
        );
        setOpenModalEdit(false);
      }
    } else {
      toast.fire("Saving Failed", "No Changes have been made", "warning");
      setEditRowId([]);
      setOpenModalEdit(false);
      setEmpTypeDataIsChange(false);
      setActionEditState(false);
      setDisabledButton(false);
      setEdit(false);
    }
  };
  // end of saving changes

  const handleBulkDelete = () => {
    const ids = selectedRows.map((row) => row.targetSystemId);
    BulkDeleteTargetSystemType(ids);
    setSelectedRows([]);
    setOpenModalDelete(false);
    setIsBulkSelected(false);
    setDisabledButton(false);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${rowsCount} ${
      rowsCount > 1 ? "Policy Management Systems" : "Policy Management System"
    }?`}</div>
  );

  const matColumns = [
    {
      title: "Policy Management System Name",
      field: "targetSystemName",
      render: (rowData) => {
        return rowData.targetSystemId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer">
            <TextInput
              placeholder="Target System Name"
              defaultValue={rowData.targetSystemName}
              onChange={(inputdata) => {
                handleEditFieldsChange(
                  "targetSystem",
                  "TargetSystemName",
                  rowData,
                  inputdata.target.value
                );
              }}
            />
          </div>
        ) : (
          <span className="text-quinary font-bold uppercase text-sm">
            {rowData.targetSystemName}
          </span>
        );
      },
    },
    {
      title: "Description",
      field: "description",
      render: (rowData) => {
        return rowData.targetSystemId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer">
            <TextInput
              placeholder="Description"
              defaultValue={rowData.description}
              onChange={(inputdata) => {
                handleEditFieldsChange(
                  "targetSystem",
                  "Description",
                  rowData,
                  inputdata.target.value
                );
              }}
            />
          </div>
        ) : (
          <span className="text-sm">{rowData.description}</span>
        );
      },
    },

    {
      title: "Created Date",
      field: "createdDate",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.targetSystemId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>
            {rowData?.createdDate
              ? new Date(rowData.createdDate).toLocaleDateString()
              : ""}
          </>
        );
      },
    },
    {
      title: "Created By",
      field: "createdBy",
      hidden: hideColumn,
      align: "left",
      render: (rowData) => {
        return (
          <div className="">
            <div className="">{rowData.createdBy}</div>
          </div>
        );
      },
    },
    {
      title: "Modified Date",
      field: "modifiedDate",
      hidden: hideColumn,
      align: "left",
      render: (rowData) => {
        return rowData.targetSystemId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>
            {rowData?.modifiedDate
              ? new Date(rowData.modifiedDate).toLocaleDateString()
              : ""}
          </>
        );
      },
    },
    {
      title: "Modified By",
      field: "modifiedBy",
      hidden: hideColumn,
      align: "left",
      render: (rowData) => {
        return rowData.targetSystemId === editRowId ? (
          <></>
        ) : (
          <div className="">
            <div className="">{rowData.modifiedBy}</div>
          </div>
        );
      },
    },
    {
      title: "Status",
      field: "isActive",
      align: "left",
      render: (rowData) => {
        return rowData.targetSystemId === editRowId ? (
          <div className="flex justify-start space-x-1 cursor-pointer">
            <input
              type="checkbox"
              className="flex items-center space-x-1 cursor-pointer"
              defaultChecked={rowData.isActive}
              onClick={(e) => {
                handleCheckBox(e.target.checked);
              }}
            />
            <label className="cursor-pointer text-green-600" name="Status">
              {checkStatus ? "Uncheck to Deactivate" : "Check to Activate"}
            </label>
          </div>
        ) : (
          <div>
            <div className="font-sans text-left mr-4 text-xs">
              {rowData.isActive ? "Active" : "Inactive"}
            </div>
          </div>
        );
      },
    },
    {
      title: "Action/s",
      align: "center",
      render: (rowData) => {
        return !userPermissions.includes(editPermission) ? (
          ""
        ) : rowData.targetSystemId === editRowId ? (
          <div className="flex justify-center gap-1">
            <SaveButton
              className={`flex shadow-md lg:text-center font-semibold text-white  gap-x-1 rounded-full  bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
            ${
              !hasTargetSystem || !empTypeDataIsChange
                ? "opacity-50"
                : "opactiy-100"
            }`}
              disabled={!hasTargetSystem || !empTypeDataIsChange}
              onClick={() => {
                setOpenModalEdit(true);
                sethideColumn(true);
              }}
            />
            <CancelButton
              className="flex lg:text-center shadow-md font-semibold text-white ml-1 gap-x-1 rounded-full bg-octonary hover:bg-octonary px-2 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-octonary focus:ring-opacity-70"
              onClick={() => {
                setActionEditState(false);
                setEditRowId([]);
                setEmpTypeDataIsChange(false);
                setEmpTypeIsExistState(false);
                setDisabledButton(false);
                sethideColumn(false);
                setEdit(false);
              }}
            />
          </div>
        ) : (
          <div className="flex items-center place-content-center mr-5">
            <EditButton
              disabled={disabledButton || selectedRows.length > 0}
              className={
                disabledButton || selectedRows.length > 0
                  ? "opacity-50 rounded-full items-center bg-quaternary text-white hover:bg-hquaternary"
                  : "opacity-100 rounded-full items-center bg-quaternary text-white hover:bg-hquaternary"
              }
              onClick={() => {
                setDisabledButton(true);
                setActionEditState(true);
                handleEditButton(rowData);
                sethideColumn(true);
              }}
            />
          </div>
        );
      },
    },
  ];

  //Filters
  const filteredItems = data
    ? data.filter(
        (item) =>
          item.targetSystemName &&
          item.targetSystemName
            .toLowerCase()
            .includes(filterText?.trim().toLowerCase())
      )
    : [];

  return (
    <div className="bg-white animate-fade-in-down">
      <div className="p-4">
        {!actionAddState && (
          <div className="">
            <div className="flex w-full">
              <div className="bg-white w-full">
                <div className="font-bold text-primary text-xl uppercase">
                  {" "}
                </div>
                <div className="flex flex-row justify-between">
                  <div className="flex flex-row item-center space-x-2">
                    <TableFilters
                      filterText={setFilterText}
                      moduleDetails="Policy Management System Name"
                      textInputName="TargetSystemName"
                      columnDetails="Target System Name"
                      disabledButton={disabledButton || selectedRows.length > 0}
                      disabledTextBox={
                        disabledButton || selectedRows.length > 0
                      }
                    ></TableFilters>
                  </div>
                  <div className="w-1/2">
                    {!userPermissions.includes(addPermission) ? (
                      ""
                    ) : (
                      <AddButton
                        buttonText="New Policy Management System"
                        className={
                          selectedRows.length > 0 || actionEditState
                            ? "opacity-50 float-right"
                            : "opacity-100 float-right"
                        }
                        onClick={() => setActionAddState(!actionAddState)}
                        disabled={disabledButton || selectedRows.length > 0}
                      />
                    )}
                  </div>
                </div>
                <div>
                  {userPermissions.includes(deletePermission) &&
                  !displayNote ? (
                    <div className="text-secondary italic text-xs3 my-2">
                      {!edit ? (
                        <div>
                          <p className="font-bold italic inline-block mr-1">
                            Note:{" "}
                          </p>
                          Tick the box to deactivate some data.
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="">
                  <MaterialExTable
                    columns={matColumns}
                    data={
                      data
                        ? targetSystemFilteredData?.length > 0
                          ? targetSystemFilteredData
                          : filterText === ""
                          ? data
                          : filteredItems
                        : []
                    }
                    options={{
                      toolbar: false,
                      showTitle: false,
                    }}
                    selection={
                      !actionEditState &&
                      userPermissions.includes(deletePermission)
                    }
                    setOpenModal={setOpenModalDelete}
                    onSelectionChange={handleSelectedRowsChange}
                    selectedRows={selectedRows}
                    isDeactivate={true}
                    isLoading={isFetching}
                  />
                </div>
              </div>
            </div>
            <ConfirmBoxModal
              ModalTitle="Update Policy Management System"
              qConfirmation=" Are you sure you want to update this?"
              isOpen={openModalEdit}
              onClose={() => setOpenModalEdit(false)}
              onClickFunction={() => {
                handleSave(empNewData);
              }}
            />
            <ConfirmBoxDelete
              ModalTitle="Deactivate Policy Management System"
              qConfirmation={deleteMessage}
              isOpen={openModalDelete}
              onClose={() => setOpenModalDelete(false)}
              onClickFunction={
                isBulkSelected ? handleBulkDelete : handleBulkDelete
              }
            />
          </div>
        )}
        {actionAddState && (
          <div className="">
            <TargetSystemForm />
          </div>
        )}
      </div>
    </div>
  );
};

export default TargetSystemTable;
